import SVGInjector, {SVGInjectorOptions} from 'svg-injector';

import {setDefaultSvgDimensions} from './setDefaultSvgDimensions';

export function injectSvgImages(context = document.body) {
    const injectMeImages = Array.from(context.querySelectorAll<HTMLImageElement>('img.inject-me:not([src=""])'));

    injectMeImages.forEach((img) => {
        injectSVG(img);
    });
}

export function injectSVG(img: HTMLImageElement) {
    if (!img.src.endsWith('.svg')) {
        return;
    }

    SVGInjector(img, optionsBase);
}

const optionsBase: SVGInjectorOptions = {
    each(svgElement) {
        // it's a string when error
        if (svgElement instanceof SVGElement) {
            removeStyleFormPathInSvg(svgElement);

            if (svgElement.closest('.editor-content')) {
                setDefaultSvgDimensions(svgElement);
                svgElement.classList.remove('inject-me');
            }
        }
    },
};

function removeStyleFormPathInSvg(svgElement: SVGElement) {
    if (svgElement instanceof SVGElement) {
        Array.from(svgElement.querySelectorAll('path')).forEach((path) => path.removeAttribute('style'));
    }
}
